import {
	DEC_CUTLERY,
	INC_CUTLERY,
	SET_ORDER_COMMENT,
	SET_PAYMENT_TYPE,
	SET_TIP_PERCENT,
	SET_USE_CASH_POINTS,
} from 'new-constants/purchase.constants';
import { getStartupParams } from 'helpers/startup-params.helper';
import { SEND_ORDER_SUCCESS } from 'new-constants/api.constants';
import { STRIPE_SUCCESS, VIPPS_SUCCESS } from 'new-constants/payment.constants';
import { DONE_INCOMPATIBLE_CART_CONFIRMATION } from 'new-constants/popup.constants';
import { PurchaseState } from './purchase.reducer.types';
import {
    CHECK_ADYEN_PAYMENT_SUCCESS,
    CHECK_PAYMENT_STATUS_SUCCESS,
    ORDER_SUCCESS,
    REPEAT_ORDER_SUCCESS, SUBMIT_APPLE_PAY_SUCCESS,
    SUBMIT_GOOGLE_PAY_SUCCESS
} from '../constants/api.constants';
import { PaymentStatuses } from "../constants/common.constants";
import { ADYEN_SUCCESS } from '../constants/payment.constants';

export const defaultPurchaseCacheEntry = {
	comment: getStartupParams().comment || '',
	tipPercent: 0,
	paymentType: null,
	subPaymentType: null,
	useCashPoints: false,
	cutlery: null,
};

const initialState: PurchaseState = {
	cache: {},
};

export const purchaseReducer = (previousState = initialState, action): PurchaseState => {
	switch (action && action.type) {
		case SET_ORDER_COMMENT:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: {
						...previousState.cache[action.restaurantId],
						comment: action.comment,
					},
				},
			};
			break;
		case SET_TIP_PERCENT:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: {
						...previousState.cache[action.restaurantId],
						tipPercent: action.percent,
					},
				},
			};
			break;
		case SET_PAYMENT_TYPE:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: {
						...previousState.cache[action.restaurantId],
						paymentType: action.paymentType,
						subPaymentType: action.subPaymentType
					},
				},
			};
			break;
		case SET_USE_CASH_POINTS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: {
						...previousState.cache[action.restaurantId],
						useCashPoints: action.useCashPoints,
					},
				},
			};
			break;

		case INC_CUTLERY: {
			const previousCutlery = previousState.cache[action.restaurantId]?.cutlery || defaultPurchaseCacheEntry.cutlery;
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: {
						...previousState.cache[action.restaurantId],
						cutlery: previousCutlery === null ? 1 : previousCutlery + 1,
					},
				},
			};
		}
			break;

		case DEC_CUTLERY: {
			const previousCutlery = previousState.cache[action.restaurantId]?.cutlery || defaultPurchaseCacheEntry.cutlery;
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: {
						...previousState.cache[action.restaurantId],
						cutlery: previousCutlery > 0 ? previousCutlery - 1 : 0,
					},
				},
			};
		}
			break;

		case SEND_ORDER_SUCCESS:
			if (action.payload.isOrderSent) {
				return {
					...previousState,
					cache: {
						...previousState.cache,
						[action.payload.data.order.restaurantId]: defaultPurchaseCacheEntry,
					},
				};
			}

			return previousState;
			break;

		case STRIPE_SUCCESS:
		case VIPPS_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: defaultPurchaseCacheEntry,
				},
			};
			break;

		case ADYEN_SUCCESS:
			if (action.payload.action.type === 'redirect' || action.payload.action.type === 'threeDS2' || action.payload.action.type === 'swish') {
				return {
					...previousState,
				}
			}
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.restaurantId]: defaultPurchaseCacheEntry,
				},
			};
			break;

        case SUBMIT_GOOGLE_PAY_SUCCESS:
        case SUBMIT_APPLE_PAY_SUCCESS:
            return {
                ...previousState,
                cache: {
                    ...previousState.cache,
                    [action.payload.restaurantId]: defaultPurchaseCacheEntry,
                },
            };
            break;

		case CHECK_PAYMENT_STATUS_SUCCESS:
			if (!(action.payload.isAdyenOrder && action.payload.data.status === PaymentStatuses.complete)) {
				return previousState;
			}

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.currentRestaurantId]: defaultPurchaseCacheEntry,
				},
			};
			break;

		case CHECK_ADYEN_PAYMENT_SUCCESS:
			if (action.payload.data.resultCode !== PaymentStatuses.authorised) {
				return previousState;
			}

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.currentRestaurantId]: defaultPurchaseCacheEntry,
				},
			};
			break;

		case ORDER_SUCCESS:
			if (!(action.payload.isScheduledForCancel && action.payload.data.order.isPaid)) {
				return previousState;
			}

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.data.order.restaurantId]: defaultPurchaseCacheEntry,
				},
			};
			break;

		case DONE_INCOMPATIBLE_CART_CONFIRMATION:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: defaultPurchaseCacheEntry,
				},
			};
			break;

		case REPEAT_ORDER_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.data.restaurantId]: {
						...defaultPurchaseCacheEntry,
						comment: action.payload.comment || defaultPurchaseCacheEntry.comment,
						cutlery: action.payload.numberOfPeople || defaultPurchaseCacheEntry.cutlery
					}
				}
			};
			break;
		default:
			return previousState;
	}
};
